<template>
  <div class="question-warp" v-if="questionData">
    <div class="question-title-warp">
      <span class="number">{{qIndex}}</span>题目 <span class="score">/本题{{questionData.contentPayload.score}}分</span>
    </div>
    <div class="question-body-warp">
      <div class="question-md-body" v-if="questionData.contentPayload.questionStem?.type === 'MARKDOWN'">
        <markdown-renderer :content="questionData.contentPayload.questionStem?.text" />
      </div>
      <div class="question-bodyImg" v-else-if="questionData.contentPayload.questionStem.image">
        <img
            :src="questionData.contentPayload.questionStem.image" alt=""/>
      </div>
      <div class="question-body" v-else v-html="questionData.contentPayload.questionStem.text"></div>
    </div>
    <div class="question-user-submit">
      <template v-if="questionData.submitPayload?.pics?.length > 0">
        <div class="submit-images" v-for="(item,index) in questionData.submitPayload?.pics" :key="index">
          <el-image :src="getImageCuttingUrl(item)" :preview-src-list="questionData.submitPayload?.pics">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
      </template>
      <div v-else class="user-submit-text">
        学生未作答<i class="el-icon-close"></i>
      </div>
      <div class="check-box">
        <div v-if="questionData.changed" class="check-tip">待保存</div>
        <span class="label">得分:</span>
        <el-input-number
            :disabled="!canMark"
            class="check-input"
            v-model="score"
            @change="handleChange"
            controls-position="right"
            :min="0"
            label="得分"></el-input-number>
      </div>
    </div>
    <div class="score-remark-inp" v-if="questionType === 'PICTURE_PROOF'">
      <p class="label">评分说明:</p>
      <el-Input type="textarea"
                class="remark"
                :rows="3"
                :disabled="!canMark"
                @input="handleRemarkChange"
                :autosize="{ minRows: 3, maxRows: 3}"
                placeholder="请输入备注" v-model="remark"></el-Input>
    </div>
  </div>
</template>

<script>
import {  InputNumber,Input,Message,Image } from 'element-ui';

  export default {
    name: 'SelectQuesTemplate',
    components:{
      'el-input-number': InputNumber,
      'el-Input': Input,
      'el-image': Image,
      'markdown-renderer': () => import('@/components/MarkdownRenderer.vue'),
    },
    props:{
      canMark:{
        type: Boolean,
        default: false
      },
      checkType:{
        type: String,
        default: ''
      },
      questionType:{
        type: String,
        default: ''
      },
      questionData:{
        type: Object,
        default(){
          return {

          }
        }
      },
      scale: {
        type: Number,
        default: 1
      },
      qIndex:{
        type: Number,
        default: 1
      },
    },
    watch:{
      questionData: {
        handler(newVal) {
          if (newVal) {
            this.score = newVal.points;
            this.remark = newVal.remark || '';
          }
        },
        immediate: true,
        deep: true
      }
    },
    data () {
      return {
        score:0,
        previewVisible: false,
        currentImageIndex: 0,
        remark:''
      }
    },
    created() {
      if(this.questionData.points){
        this.score = this.questionData.points;
      }
      if(this.questionData.validatePayload?.scoreDesc){
        this.remark = this.questionData.validatePayload?.scoreDesc;
      }
    },
    methods :{
      handleRemarkChange(val) {
        this.$emit('remark-change', { index: this.qIndex - 1, remark: val });
      },
      handleChange (val) {
        if (val > this.questionData.contentPayload.score) {
          this.$message.warning('分数不能大于' + this.questionData.contentPayload.score);
          this.$nextTick(() => {
            this.score = this.questionData.contentPayload.score;
          });
        }
        this.$emit('score-change', { index: this.qIndex - 1, score: val > this.questionData.contentPayload.score ?  this.questionData.contentPayload.score : val});
      },
      getImageCuttingUrl (url) {
        return url + '?imageView&thumbnail=100x0';
      }
    }
  }
</script>

<style scoped lang="less">
  .question-warp{
    margin-bottom: 50px;
    position: relative;
    .question-title-warp{
      display: flex;
      align-items: center;
      color: #000;
      font-size: 18px;
      margin-bottom: 16px;
      .number{
        width: 28px;
        height: 28px;
        background: #F5F6F9;
        border-radius: 42px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        color: rgba(4, 4, 4, 0.9);
      }
      .score{
        margin-left: 8px;
        font-size: 16px;
        color: #7D8087;
      }
    }
    .question-body-warp{
      width: 100%;
      .question-bodyImg{
        min-height: 440px;
        max-height: 552px;
        img{
          width: 100%;
          object-fit: contain;
        }
      }
    }
    .question-user-submit{
      margin-top: 16px;
      display: flex;
      align-items: center;
      position: relative;
      min-height: 80px;
      .user-submit-text{
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        background: #FFECE8;
        color: #F53F3F;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        position: absolute;
        left: 0;
        bottom: -20px;
        i{
          margin-left: 4px;
        }
      }
      .submit-images{
        overflow: hidden;
        background: #F5F7FA;
        padding: 9px;
        box-sizing: border-box;
        margin-right: 20px;
        max-width: 110px;
        height: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
        .image-slot{
          color: #363739;
          font-size: 12px;
        }
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
    }
    .check-box {
      position: absolute;
      bottom:-20px;
      right: 0;
      display: flex;
      align-items: center;
      .check-tip {
        position: absolute;
        left: 53px;
        bottom: -20px;
        font-size: 12px;
        // color: #F53F3F;
        color: #7D8087E5;
      }
      .label {
        color: #000;
        font-size: 18px;
        margin-right: 12px;
        font-weight: bold;
      }
      .check-input{
        width: 153px;
        height: 40px;
        font-size: 16px;
        color: #7D8087E5;
      }
    }
    .score-remark-inp{
      margin-top: 28px;
      color: #000;
      font-size: 18px;
      .label{
        font-weight: 500;
        margin-bottom: 8px;
      }
      .remark{

      }
    }
  }
</style>
<style lang="less">
.question-body{
  margin-top: 4px;
  p {
    font-size: 20px;
    margin-bottom: 16px;
    color: #202F42;
    line-height:26px;
    img{
      max-width: 100%;
      display: inline;
    }
  }
  img{
    max-width: 100%;
  }
}
</style>